import { Box, Container, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { Page } from 'src/components';
import { SellOutFilters } from './components';
import { SellOutSummmary } from './components/SellOutSummary';
import { SellOutListings } from './components/SellOutListings';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const SellOutView = () => {
  const classes = useStyles();

  return (
    <Page title={'Sell Out'} className={classes.root}>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        sx={{ px: 3 }}
      >
        <Typography color="textPrimary" gutterBottom variant="h3">
          Sell Out
        </Typography>
      </Box>
      <Container maxWidth={false}>
        <SellOutFilters />
        <SellOutSummmary />
        <SellOutListings />
      </Container>
    </Page>
  );
};

export default SellOutView;
